import * as React from 'react';
import classNames from 'classnames';
import './index.less';
import ABSSubTitle from '../ABSSubTitle';
import ABSPre from '../ABSPre';

interface IABSSectionProps {
  title?: string;
  content?: string;
  noTextIndent?: boolean;
}

export default class ABSSection extends React.Component<IABSSectionProps, any> {
  render() {
    const { title, content, noTextIndent } = this.props;
    const clazz = classNames('abs-agreement-section-content', { 'no-text-indent': noTextIndent });
    return (
      <div className="abs-agreement-section">
        <ABSSubTitle title={title} className="abs-agreement-section-title" />
        <ABSPre className={clazz}>
          {content ? content : this.props.children}
        </ABSPre>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSection/index.tsx